import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import filterTypes from "data/filter-types";
import transactionTypes from "data/transaction-types";
import findFilterValue from "helpers/find-filter-value";
import searchOperationGenerator from "helpers/search-operation-generator";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import {
  getFilters,
  getCurrencies,
  getStatuses,
  getTypes
} from "actions/transaction/actions";

class TransactionFilers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.getFilters();
    this.props.getCurrencies();
    this.props.getStatuses();
    this.props.getTypes();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    } else if (!_.isEqual(nextProps.currencies, this.props.currencies)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.setState({
      filters: {}
    }, this.props.handleReset);
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  render() {
    const {
      currencies,
      statuses,
      types,
      activeFilters,
      totalCount,
      transactionFilters
    } = this.props;
    const {
      isOpen
    } = this.state;

    // paymentSystemTransactionId: ["EQUALS"]

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title="Transaction"
          totalCount={totalCount}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-3" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="walletId"
                  placeholder="User ID"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(transactionFilters.walletId)}
                  value={findFilterValue("walletId", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="amount"
                  placeholder="Amount"
                  filterType="number"
                  onChange={(name, valueObject) => {
                    if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                      this.handleChangeFilter(name, {
                        ...valueObject,
                        fieldValue: parseFloat(valueObject.fieldValue)
                      });
                    } else {
                      this.handleChangeFilter(name, {});
                    }
                  }}
                  searchOperation={searchOperationGenerator(transactionFilters.amount)}
                  value={findFilterValue("amount", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="currency"
                  placeholder="Currency"
                  filterType="select_multiple"
                  filterTypeOptions={currencies.map(value => ({
                    label: value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(transactionFilters.currency)}
                  defaultFilterType={filterTypes.IN.value}
                  value={findFilterValue("currency", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="startDate"
                  placeholder="Start"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(transactionFilters.startDate)}
                  value={findFilterValue("startDate", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="endDate"
                  placeholder="End"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(transactionFilters.endDate)}
                  value={findFilterValue("endDate", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="orderNumber"
                  placeholder="Order #"
                  filterType="number"
                  defaultValue=""
                  onChange={(name, valueObject) => {
                    if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                      this.handleChangeFilter(name, {
                        ...valueObject,
                        fieldValue: parseFloat(valueObject.fieldValue)
                      });
                    } else {
                      this.handleChangeFilter(name, {});
                    }
                  }}
                  searchOperation={searchOperationGenerator(transactionFilters.orderNumber)}
                  value={findFilterValue("orderNumber", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="status"
                  placeholder="Status"
                  filterType="select_multiple"
                  filterTypeOptions={statuses.map(value => ({
                    label: value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(transactionFilters.status)}
                  defaultFilterType={filterTypes.IN.value}
                  value={findFilterValue("status", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="type"
                  placeholder="Type"
                  filterType="select_multiple"
                  filterTypeOptions={types.map(value => ({
                    label: transactionTypes[value] || value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(transactionFilters.type)}
                  defaultFilterType={filterTypes.IN.value}
                  value={findFilterValue("type", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="paymentSystemTransactionId"
                  placeholder="PS Transaction ID"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(transactionFilters.paymentSystemTransactionId)}
                  value={findFilterValue("paymentSystemTransactionId", activeFilters)}
                />
              </div>

              <div className="col-12 col-md-3 mb-3 offset-md-6">
                <div className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm ml-2"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

TransactionFilers.defaultProps = {
  activeFilters: []
};

TransactionFilers.propTypes = {
  activeFilters: PropTypes.array.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  transactionFilters: state.transaction.transactionFilters,
  currencies: state.transaction.currencies,
  statuses: state.transaction.statuses,
  types: state.transaction.types,
});

const mapStateToDispatch = dispatch => ({
  getFilters: bindActionCreators(getFilters, dispatch),
  getCurrencies: bindActionCreators(getCurrencies, dispatch),
  getStatuses: bindActionCreators(getStatuses, dispatch),
  getTypes: bindActionCreators(getTypes, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(TransactionFilers);



// WEBPACK FOOTER //
// ./src/views/pages/transaction/filters.js